import React from 'react'
import { TiTimes } from 'react-icons/ti';
import { AuthButton } from '../../Containers';
import { FaCartPlus } from "react-icons/fa";
import axios from 'axios';
import { toast } from 'react-toastify';

function PayInProgress({ name,close, setOpenProgressModal,setOpenModal, promo, isSuccess,onSuccess,onClose,setRemovePromo,handlePayment,obj}) {
    const token = localStorage.getItem("token");

    const handleSavePlan = async() => {
        const {data} = await axios.post(`${process.env.REACT_APP_API_URL}/v1/request_log`, obj, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${token}`
            }
        });

        if (data) {
            if (promo) {
                setRemovePromo(true);
                setOpenModal(true);  
                setOpenProgressModal(false);
              } else {
                handlePayment(onSuccess, onClose);
                setOpenProgressModal(false);
              }
        }
        toast.success('successful',{
          position:'bottom-right'
        })
        
    }
  return (
    <>
      {isSuccess ? (
        <>
          {
            (isSuccess) &&
            <div className='z-[999999] fixed top-[50%] right-[50%] translate-x-[50%] translate-y-[-50%]  max-w-[650px] h-[410px] flex flex-col  items-center border py-[32px] border-[#EDF2F7] rounded-[16px] bg-white'>
              <div className='w-full relative flex justify-center'>
                <div className='text-[#1A202C] font-bold text-[20px]'></div>
                <TiTimes className='cursor-pointer absolute top-[10%] right-[5%]' onClick={() => {
                  close();
                  
                }} color={"#17599A"} />
              </div>
              <div className='w-full mt-[48px] px-[32px] overflow-y-scroll'>
                <div className='w-full relative mb-[15px]'>
                  <div className="flex justify-between w-full h-full p-[20px] rounded-[12px] ">
                    <div className='w-full h-full flex flex-col justify-center items-center'>
                      <div>
                        <FaCartPlus color="#50C878" size={120} />
                      </div>
                      <div className='w-full text-center mt-[20px] font-semibold text-[18px] md:text-[28px]'>1 {' '} {name}  added</div>
                    </div>
                    
                  </div>
                  <AuthButton onClick={handleSavePlan} className="my-5 bg-[#E6072C]">Save and Proceed</AuthButton>
                </div>
              </div>
            </div>
          }
          <div className={`fixed top-0 inset-0 z-[9999] bg-[rgba(26,32,44,0.3)] backdrop-blur-[2px]`}></div>
        </>
      ) : null}
    </>
  )
}

export default PayInProgress